import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import InicioView from "../views/InicioView.vue";
import ListarPerifericosView from "../views/ListarPerifericosView.vue";
import DashboardsTIView from "../views/DashboardsTIView.vue";
import NotFoundView from "../views/NotFoundView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { isPublic: true },
  },
  {
    path: "/inicio",
    name: "inicio",
    component: InicioView,
    meta: { requiresAuth: true },
  },
  {
    path: "/colaboradores/listar",
    name: "listarColaboradores",
    component: () => import("../views/ListarColaboradoresView.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/perifericos",
    name: "listarPerifericos",
    component: ListarPerifericosView,
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/perifericos/listar",
    redirect: "/perifericos",
  },
  {
    path: "/devices",
    name: "ListarDevices",
    component: () => import("../views/ListarDevice.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/devices/:id",
    name: "EquipoDetalle",
    component: () => import("../views/EquipoDetalleView.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/dashboards",
    name: "DashboardsTI",
    component: DashboardsTIView,
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/logs-administrativos",
    name: "LogsTI",
    component: () => import("../views/LogTIView.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/actas",
    name: "listarActas",
    component: () => import("../views/ListarActasView.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/usuarios",
    name: "listarUsuarios",
    component: () => import("../views/ListarUsuariosView.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "/usuarios/crear",
    name: "crearUsuario",
    component: () => import("../views/CrearUsuarioView.vue"),
    meta: { requiresAuth: true, rolesPermitidos: ["adminTI"] },
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let usuario = null;
  try {
    usuario = JSON.parse(sessionStorage.getItem("usuario") || localStorage.getItem("usuario") || "null");
  } catch (e) {
    usuario = null;
  }

  if (to.meta.requiresAuth && !usuario) {
    return next("/");
  }

  if (to.meta.rolesPermitidos && usuario) {
    const rolUsuario = (usuario.rol || "").trim().toLowerCase();
    const rolesPermitidos = (to.meta.rolesPermitidos || []).map((r) => String(r || "").trim().toLowerCase());
    if (!rolesPermitidos.includes(rolUsuario)) {
      sessionStorage.setItem(
        "pendingNotify",
        JSON.stringify({ text: "⛔ Acceso no autorizado.", color: "error", icon: "mdi-shield-lock" })
      );
      return next("/inicio");
    }
  }

  next();
});

export default router;
